<template>
	<my-dialog :visible.sync="dialogVisible" :title="contentTitle" dialog-type="form" @close="handleClose">
		<el-form ref="editForm" label-width="8.75rem" :model="editForm" class="demo-form-inline ml-20">
			<el-form-item label="更新包上传">
				<chunkUpload v-if="showImg" v-model="fileList" :accept-parm="appAccept" :file-limit="1" @input="handleInput" />
			</el-form-item>
		</el-form>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" icon="el-icon-check" :loading="saveloading" class="title" @click="submitForm('editForm')">保存</el-button>
			</div>
		</template>
	</my-dialog>
</template>
<script>
import chunkUpload from "../../../components/chunkUpload.vue";
import { AppSystemUpdate, WebSystemUpdate } from "../../../api/systemApi.js";
export default {
	components: {
		chunkUpload
	},
	data() {
		return {
			tableRow: {},
			saveloading: false,
			editForm: {
				uploadPath: ""
			},
			dialogVisible: false,
			contentTitle: "",
			fileList: [],
			showImg: true,
			type: 1,
			appAccept: ".zip,.rar,.7z"
		};
	},
	created() {},
	methods: {
		editShow(type) {
			this.type = type;
			this.contentTitle = `${type === 1 ? "app" : "web"}版本管理`;
			this.fileList = this.$options.data.call(this).fileList;
			this.editForm = this.$options.data.call(this).editForm;
			this.showImg = true;
			this.dialogVisible = true;
		},
		handleClose() {
			this.showImg = false;
			// this.$refs['editForm'].resetFields();
			this.fileList = [];
			this.dialogVisible = false;
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			if (this.editForm.uploadPath == "") {
				this.$message({
					type: "info",
					message: "请上传文件"
				});
				return;
			}
			this.$refs[editData].validate((valid) => {
				if (valid) {
					this.saveloading = true;
					if (this.type === 1) {
						this.saveApp();
					} else {
						this.saveWeb();
					}
				} else {
					return false;
				}
			});
		},
		saveApp() {
			AppSystemUpdate(this.editForm)
				.then((res) => {
					if (res.code == 1) {
						this.dialogVisible = false;
						this.$parent.getListData();
						this.$message({
							type: "success",
							message: "保存成功！"
						});
						this.saveloading = false;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
						this.saveloading = false;
					}
				})
				.catch((err) => {
					this.dialogVisible = false;
					this.saveloading = false;
					this.$message.error("保存失败，请稍后再试！");
				});
		},
		saveWeb() {
			WebSystemUpdate(this.editForm)
				.then((res) => {
					if (res.code == 1) {
						this.dialogVisible = false;
						this.$parent.getListData();
						this.$message({
							type: "success",
							message: "保存成功！"
						});
						this.saveloading = false;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
						this.saveloading = false;
					}
				})
				.catch((err) => {
					this.dialogVisible = false;
					this.saveloading = false;
					this.$message.error("保存失败，请稍后再试！");
				});
		},
		handleInput(file) {
			if (file.length > 0) {
				this.editForm.uploadPath = file[0].url;
			} else {
				this.editForm.uploadPath = "";
			}
		}
	}
};
</script>
<style scoped></style>
